import api from './api';

export const getSupplyRequests = (params) => api.get('/supply-requests', { params });

export const createSupplyRequest = (data) => api.post('/supply-requests', data);

export const updateSupplyRequest = (requestId, data) => api.patch(`/supply-requests/${requestId}`, data);

export const addSupplyRequestLocalNote = (requestId, data) => api.post(`/supply-requests/${requestId}/notes`, data);

export const runSupplyRequestPullSync = () => api.post('/supply-requests/sync/pull');

export const getAdminSupplyRequests = (params) => api.get('/admin/supply-requests', { params });

export const adminBulkUpdateSupplyRequestsStatus = (requestIds, status, visibleStatusLabel, pushToWrikeNow = false) =>
	api.patch('/admin/supply-requests/bulk/status', { requestIds, status, visibleStatusLabel, pushToWrikeNow });

export const adminBulkMoveSupplyRequests = (requestIds, targetSpaceId) =>
	api.patch('/admin/supply-requests/bulk/move', { requestIds, targetSpaceId });

export const adminBulkDeleteSupplyRequestsLocal = (requestIds) =>
	api.delete('/admin/supply-requests/bulk', { data: { requestIds } });

export const adminCleanupMirroredSupplyRequestTasks = (options = {}) =>
	api.post('/admin/supply-requests/cleanup-mirrored-tasks', options);
